import { createAction, props } from "@ngrx/store";

export const fetchCategories = createAction(
  "[Category] Fetch Categories",
  props<{ page; filterOptions }>()
);

export const fetchCategoriesSuccess = createAction(
  "[Banner] Fetch Categories Success",
  props<{ category }>()
);

export const fetchCategoriesFailure = createAction(
  "[Category] Fetch Categories Faild",
  props<{ error }>()
);

export const setActiveCategory = createAction(
  "[Category] Set Active Category",
  props<{ item }>()
);
